import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { completeQuiz } from '../utils/quizUtils';
import { updateQuizProgress } from '../utils/funnelDataUtils';
import bgImg0 from '../assets/images/07quiz-bg0.png';
import bgImg2 from '../assets/images/07quiz2-bg2.png';
import titleImg from '../assets/images/05tale-title-txt.png';
import zone1Img from '../assets/images/07quiz2-zone2.png';
import quizImg from '../assets/images/07quiz2-quiz.png';
import btn1Img from '../assets/images/07quiz-btn1.png';
import btn2Img from '../assets/images/07quiz-btn2.png';
import hintImg from '../assets/images/07quiz2-hint.png';
import hint2Img from '../assets/images/07quiz2-hint2.png';
import hintOkBtnImg from '../assets/images/06quiz-hintOk-btn.png';
import confirmBtnImg from '../assets/images/quiz-confirm.png';
import exitBtnImg from '../assets/images/quiz-exit.png';
import skipBtnImg from '../assets/images/quiz-skip.png';
import clearImg from '../assets/images/07quiz2-clear.png';
import failImg from '../assets/images/07quiz2-fail.png';
import successCoinImg from '../assets/images/07quiz2-success-coin.png';
import failCoinImg from '../assets/images/quiz-fail-coin.png';
// EXIT 기능을 위한 새로운 이미지들
import exitPopupImg from '../assets/images/quiz-skip-img.png';
import exitCoinGetImg from '../assets/images/skip-coin-get.png';
import prevBtnImg from '../assets/images/02register-prev-btn.png';
import okBtnImg from '../assets/images/02register-ok-btn.png';
import questionImg from '../assets/images/02register-question.png';
import tipOverlayImg from '../assets/images/quiz-tip-overlay.png';
import Bookmark from '../components/Bookmark';
import ExitPopupComponent from '../components/ExitPopup';
import BluePopup from '../components/BluePopup';
import { withUrlValidation } from '../components/withUrlValidation';
import { useSessionNavigation } from '../hooks/useSessionNavigation';
import { soundManager } from '../utils/soundUtils';
import FirebaseErrorPopup from '../components/FirebaseErrorPopup';
import { useFirebaseError } from '../hooks/useFirebaseError';

const FadeInBackground = styled.div<{ visible: number; bgImage: string }>`
  width: 100vw;
  min-height: 100vh;
  background: url(${({ bgImage }) => bgImage}) center/cover no-repeat;
  background-position: center top;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  opacity: ${({ visible }) => visible};
  transition: opacity 1.5s ease;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: black;
    opacity: ${({ visible }) => 1 - visible};
    transition: opacity 1.5s ease;
    z-index: -1;
  }
`;

const Title = styled.img<{ visible: number }>`
  width: 85vw;
  max-width: 65vw;
  margin-top: 15dvw;
  margin-bottom: 4dvh;
  opacity: ${({ visible }) => visible};
  transition: opacity 1.5s ease;
  z-index: 10;
`;

const Zone1 = styled.img<{ visible: number }>`
  width: 90vw;
  max-width: 60vw;
  margin-top: 5dvh;
  opacity: ${({ visible }) => visible};
  transition: opacity 1.5s ease;
  z-index: 10;
`;

const Quiz = styled.img<{ visible: number }>`
  width: 90vw;
  max-width: 80vw;
  margin-top: 3dvh;
  opacity: ${({ visible }) => visible};
  transition: opacity 1.5s ease;
  z-index: 10;
`;

const QuizButtonsContainer = styled.div<{ visible: number }>`
  display: flex;
  flex-direction: column;
  gap: 0.5dvh;
  margin-top: 5dvh;
  opacity: ${({ visible }) => visible};
  transition: opacity 1.5s ease;
  z-index: 10;
`;

const QuizButtonContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => !['isSelected', 'visible'].includes(prop)
})<{ isSelected: boolean; visible: boolean }>`
  position: relative;
  width: 80vw;
  max-width: 300px;
  cursor: ${({ visible }) => visible ? 'pointer' : 'default'};
  transition: all 0.3s ease;
  pointer-events: ${({ visible }) => visible ? 'auto' : 'none'};
  
  &:active {
    transform: ${({ visible }) => visible ? 'scale(0.95)' : 'scale(1)'};
  }
`;

const QuizButton = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

const QuizButtonText = styled.div<{ isSelected: boolean }>`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-family: 'MapoDPP', sans-serif;
  font-size: 1.15rem;
  font-weight: 500;
  color: #14AD8E;
  text-align: center;
  white-space: nowrap;
  transition: color 0.3s ease;
`;

const HintButton = styled.img<{ visible: boolean }>`
  width: 12vw;
  max-width: 200px;
  margin-top: 2.5dvh;
  cursor: ${({ visible }) => visible ? 'pointer' : 'default'};
  transition: all 0.3s ease;
  pointer-events: ${({ visible }) => visible ? 'auto' : 'none'};
  opacity: ${({ visible }) => visible ? 1 : 0};
  
  &:hover {
    transform: ${({ visible }) => visible ? 'scale(1.05)' : 'scale(1)'};
  }
  
  &:active {
    transform: ${({ visible }) => visible ? 'scale(0.95)' : 'scale(1)'};
  }
`;

const ConfirmButton = styled.img<{ visible: boolean }>`
  width: 75vw;
  margin-top: 2.5dvh;
  cursor: ${({ visible }) => visible ? 'pointer' : 'default'};
  transition: all 0.3s ease;
  pointer-events: ${({ visible }) => visible ? 'auto' : 'none'};
  opacity: ${({ visible }) => visible ? 1 : 0};
  
  &:hover {
    transform: scale(1.05);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

const ExitButton = styled.img`
  position: absolute;
  margin-top: 0.5dvh;
  margin-left: 1.5dvw;
  top: 3.4dvw;
  left: 2.3dvw;
  width: 20dvw;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 9999;
  
  &:hover {
    transform: scale(1.05);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

const SkipButton = styled.img`
  position: absolute;
  margin-top: 0.5dvh;
  margin-left: 1.5dvw;
  top: 3.4dvw;
  left: 23dvw;
  width: 20dvw;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 9999;
  
  &:hover {
    transform: scale(1.05);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

const TipButton = styled.img`
  position: absolute;
  bottom: 5.3dvw;
  right: 4.2dvw;
  width: 4dvw;
  max-width: 60px;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 50;
  
  &:hover {
    transform: scale(1.05);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

const TipOverlay = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'visible'
})<{ visible: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(${tipOverlayImg}) center/cover no-repeat;
  z-index: 1000;
  cursor: pointer;
  opacity: ${({ visible }) => visible ? 1 : 0};
  visibility: ${({ visible }) => visible ? 'visible' : 'hidden'};
  transition: opacity 0.3s ease, visibility 0.3s ease;
`;

const HintPopup = styled.div<{ visible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  opacity: ${({ visible }) => visible ? 1 : 0};
  visibility: ${({ visible }) => visible ? 'visible' : 'hidden'};
  transition: all 0.3s ease;
`;

const HintPopupContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const HintPopupImage = styled.img`
  width: 80%;
  max-width: 400px;
`;

const HintOkButton = styled.img`
  position: absolute;
  bottom: 8%;
  left: 50%;
  transform: translateX(-50%);
  width: 45%;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateX(-50%) scale(1.05);
  }
  
  &:active {
    transform: translateX(-50%) scale(0.95);
  }
`;

const ClearPopup = styled.div<{ visible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 200;
  opacity: ${({ visible }) => visible ? 1 : 0};
  visibility: ${({ visible }) => visible ? 'visible' : 'hidden'};
  transition: all 0.5s ease;
`;

const ClearPopupImage = styled.img<{ visible: boolean }>`
  width: 70%;
  animation: ${({ visible }) => visible ? 'fadeInScale 0.5s ease' : 'none'};
  
  @keyframes fadeInScale {
    from {
      opacity: 0;
      transform: scale(0.8);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

const FailPopup = styled.div<{ visible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 200;
  opacity: ${({ visible }) => visible ? 1 : 0};
  visibility: ${({ visible }) => visible ? 'visible' : 'hidden'};
  transition: all 0.5s ease;
`;

const FailPopupImage = styled.img<{ visible: boolean }>`
  width: 70%;
  animation: ${({ visible }) => visible ? 'fadeInScale 0.5s ease' : 'none'};
  
  @keyframes fadeInScale {
    from {
      opacity: 0;
      transform: scale(0.8);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

const SuccessCoinPopup = styled.div<{ visible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 300;
  opacity: ${({ visible }) => visible ? 1 : 0};
  visibility: ${({ visible }) => visible ? 'visible' : 'hidden'};
  transition: all 0.5s ease;
`;

const SuccessCoinPopupContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SuccessCoinPopupImage = styled.img<{ visible: boolean }>`
  width: 83%;
  opacity: ${({ visible }) => visible ? 1 : 0};
  transform: ${({ visible }) => visible ? 'scale(1)' : 'scale(0.8)'};
  transition: all 0.5s ease;
`;

const FailCoinPopup = styled.div<{ visible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 300;
  opacity: ${({ visible }) => visible ? 1 : 0};
  visibility: ${({ visible }) => visible ? 'visible' : 'hidden'};
  transition: all 0.5s ease;
`;

const FailCoinPopupContent = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const FailCoinPopupImage = styled.img<{ visible: boolean }>`
  width: 83%;
  animation: ${({ visible }) => visible ? 'fadeInScale 0.5s ease' : 'none'};
  
  @keyframes fadeInScale {
    from {
      opacity: 0;
      transform: scale(0.8);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

const CoinPopupOkButton = styled.img<{ visible: boolean }>`
  position: absolute;
  bottom: 0%;
  left: 50%;
  transform: translateX(-50%);
  width: 45%;
  cursor: pointer;
  opacity: ${({ visible }) => visible ? 1 : 0};
  transition: opacity 0.5s ease 0.3s;
  
  &:hover {
    transform: translateX(-50%) scale(1.05);
  }
  
  &:active {
    transform: translateX(-50%) scale(0.95);
  }
`;

const Quiz2Page: React.FC = () => {
  const [bgVisible, setBgVisible] = useState(0);
  const [bookmarkVisible, setBookmarkVisible] = useState(0);
  const [currentBgImage, setCurrentBgImage] = useState(bgImg0);
  const [isFadeInComplete, setIsFadeInComplete] = useState(false);
  const [isBgChanged, setIsBgChanged] = useState(false);
  const [titleVisible, setTitleVisible] = useState(0);
  const [zone1Visible, setZone1Visible] = useState(0);
  const [quizVisible, setQuizVisible] = useState(0);
  const [quizButtonsVisible, setQuizButtonsVisible] = useState(0);
  const [hintVisible, setHintVisible] = useState(false);
  const [showHintPopup, setShowHintPopup] = useState(false);
  const [selectedQuiz, setSelectedQuiz] = useState<number | null>(null);
  const [confirmButtonVisible, setConfirmButtonVisible] = useState(false);
  const [showClearPopup, setShowClearPopup] = useState(false);
  const [showFailPopup, setShowFailPopup] = useState(false);
  const [showSuccessCoinPopup, setShowSuccessCoinPopup] = useState(false);
  const [showFailCoinPopup, setShowFailCoinPopup] = useState(false);
  const [isCorrectAnswer, setIsCorrectAnswer] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [containerHeight, setContainerHeight] = useState('100vh');
  // EXIT 기능을 위한 상태 변수들
  const [showExitPopup, setShowExitPopup] = useState(false);
  // SKIP 기능을 위한 상태 변수들
  const [showSkipPopup, setShowSkipPopup] = useState(false);
  const [showSkipButtons, setShowSkipButtons] = useState(false);
  // TIP 기능을 위한 상태 변수들
  const [showTipOverlay, setShowTipOverlay] = useState(false);
  const { navigateWithSession } = useSessionNavigation();
  
  // Firebase 에러 핸들링 훅
  const { errorState, handleFirebaseError, hideError } = useFirebaseError();

  useEffect(() => {
    // 퀴즈 진입 추적
    updateQuizProgress(2, 'entries');
    
    // 애니메이션 시퀀스
    const bgTimer = setTimeout(() => setBgVisible(1), 100);
    const bookmarkTimer = setTimeout(() => setBookmarkVisible(1), 700);
    const fadeInCompleteTimer = setTimeout(() => setIsFadeInComplete(true), 1500); // 1.5초
    
    return () => {
      clearTimeout(bgTimer);
      clearTimeout(bookmarkTimer);
      clearTimeout(fadeInCompleteTimer);
    };
  }, []);

  // 배경 변경 후 순차 애니메이션
  useEffect(() => {
    if (isBgChanged) {
      const titleTimer = setTimeout(() => setTitleVisible(1), 100);
      const zone1Timer = setTimeout(() => setZone1Visible(1), 500);
      const quizTimer = setTimeout(() => setQuizVisible(1), 1500);
      const quizButtonsTimer = setTimeout(() => setQuizButtonsVisible(1), 2000);
      const hintTimer = setTimeout(() => setHintVisible(true), 2500);
      
      return () => {
        clearTimeout(titleTimer);
        clearTimeout(zone1Timer);
        clearTimeout(quizTimer);
        clearTimeout(quizButtonsTimer);
        clearTimeout(hintTimer);
      };
    }
  }, [isBgChanged]);

  useEffect(() => {
    // 배경 이미지 로딩 후 실제 비율 계산
    const img = new Image();
    img.onload = () => {
      const aspectRatio = img.height / img.width;
      const containerWidth = window.innerWidth;
      const calculatedHeight = containerWidth * aspectRatio;
      setContainerHeight(`${calculatedHeight}px`);
    };
    img.src = currentBgImage;
  }, [currentBgImage]);

  const handleBackgroundClick = () => {
    if (isFadeInComplete && !isBgChanged) {
      setCurrentBgImage(bgImg2);
      setIsBgChanged(true);
    }
  };

  const handleQuizButtonClick = (quizIndex: number) => {
    soundManager.playButtonClick();
    setSelectedQuiz(quizIndex);
    setConfirmButtonVisible(true);
  };

  // 사용자 데이터 업데이트 함수
  const updateUserData = async (isSuccess: boolean): Promise<boolean> => {
    try {
      const currentUser = localStorage.getItem('currentUser');
      if (!currentUser) {
        console.error('로그인된 사용자 정보가 없습니다.');
        alert('로그인 정보를 찾을 수 없습니다. 다시 로그인해주세요.');
        return false;
      }

      const userData = JSON.parse(currentUser);
      
      // 이미 퀴즈를 풀었는지 확인 (로컬 스토리지에서)
      const currentZoneStatus = userData.zoneClearStatus?.zone2 || '아직안품';
      if (currentZoneStatus !== '아직안품') {
        return true; // 이미 풀었으면 성공으로 처리하되 업데이트는 하지 않음
      }

      // 새로운 퀴즈 완료 처리 함수 사용
      const result = await completeQuiz(
        2, // zone2
        isSuccess,
        userData.nickname,
        userData.avatarNumber,
        userData.coinCount || 0
      );

      if (!result.success) {
        console.error('퀴즈 완료 처리에 실패했습니다.');
        alert('데이터 저장 중 오류가 발생했습니다. 다시 시도해주세요.');
        return false;
      }

      
      return true;
    } catch (error) {
      console.error('사용자 데이터 업데이트 중 오류:', error);
      // Firebase 에러 팝업 표시
      handleFirebaseError(error, '퀴즈 데이터 저장 중 오류가 발생했습니다.');
      return false;
    }
  };

  const handleConfirmButtonClick = async () => {
    if (selectedQuiz === null || isProcessing) return;
    
    soundManager.playButtonClick();
    setIsProcessing(true); // 처리 시작
    
    try {
      // 1번이 정답 (index: 0) - 퀴즈2에서는 정답을 1번으로 변경
      if (selectedQuiz === 0) {
        setIsCorrectAnswer(true);
        // 퀴즈 정답 추적
        updateQuizProgress(2, 'correct');
        // 사용자 데이터 업데이트 (성공)
        const updateSuccess = await updateUserData(true);
        if (updateSuccess) {
          // 다른 요소들을 숨기고 클리어 팝업 표시
          setTimeout(() => {
            setQuizVisible(0);
            setQuizButtonsVisible(0);
            setHintVisible(false);
            setConfirmButtonVisible(false);
            setShowClearPopup(true);
          }, 500);
        }
      } else {
        // 틀린 답 선택 시 실패 팝업 표시
        // 퀴즈 오답 추적
        updateQuizProgress(2, 'incorrect');
        // 사용자 데이터 업데이트 (실패)
        const updateSuccess = await updateUserData(false);
        if (updateSuccess) {
          setTimeout(() => {
            setQuizVisible(0);
            setQuizButtonsVisible(0);
            setHintVisible(false);
            setConfirmButtonVisible(false);
            setShowFailPopup(true);
          }, 500);
        }
      }
    } catch (error) {
      console.error('퀴즈 처리 중 오류:', error);
    } finally {
      setIsProcessing(false); // 처리 완료
    }
  };

  const handleExitButtonClick = () => {
    soundManager.playButtonClick();
    // 팁 오버레이가 켜져있으면 먼저 끄기
    if (showTipOverlay) {
      setShowTipOverlay(false);
    }
    
    // 북마크에서 ProgressCard가 열려있을 때 이벤트 발생
    window.dispatchEvent(new CustomEvent('quizExit'));
    
    // EXIT 팝업 표시
    setShowExitPopup(true);
  };

  // EXIT 팝업 관련 핸들러들
  const handleExitPopupClose = () => {
    setShowExitPopup(false);
  };

  const handleExitConfirmed = () => {
    setShowExitPopup(false);
    navigateWithSession('/progress-card?from=exit');
  };

  const handleSkipButtonClick = () => {
    soundManager.playButtonClick();
    // 팁 오버레이가 켜져있으면 먼저 끄기
    if (showTipOverlay) {
      setShowTipOverlay(false);
    }
    
    // 북마크에서 ProgressCard가 열려있을 때 이벤트 발생
    window.dispatchEvent(new CustomEvent('quizSkip'));
    
    // SKIP 팝업 표시
    setShowSkipPopup(true);
    setShowSkipButtons(false); // 버튼 초기화
    
    // 0.5초 후에 버튼들 표시
    setTimeout(() => {
      setShowSkipButtons(true);
    }, 500);
  };

  // SKIP 팝업 관련 핸들러들
  const handleSkipPopupClose = () => {
    setShowSkipPopup(false);
    setShowSkipButtons(false);
  };

  const handleSkipConfirmed = async () => {
    setShowSkipPopup(false);
    setShowSkipButtons(false);
    
    // SKIP 버튼 클릭 정보 저장
    const currentUser = localStorage.getItem('currentUser');
    if (currentUser) {
      const userData = JSON.parse(currentUser);
      await saveButtonClickInfo('quiz2', 'skip', userData.nickname);
    }
    
    // 사용자 데이터 업데이트 (실패로 처리)
    const updateSuccess = await updateUserData(false);
    if (updateSuccess) {
      // 실패 시퀀스로 진행
      setTimeout(() => {
        setQuizVisible(0);
        setQuizButtonsVisible(0);
        setHintVisible(false);
        setConfirmButtonVisible(false);
        setShowFailPopup(true);
      }, 500);
    }
  };

  // 버튼 클릭 정보를 DB에 저장하는 함수
  const saveButtonClickInfo = async (page: string, buttonType: string, nickname: string) => {
    try {
      console.log('버튼 클릭 정보 저장 시작:', { page, buttonType, nickname });
      
      // 사용자 생성 후 2시간 유효하므로 현재 시간과 1시간 전 컬렉션만 확인
      const { db } = await import('../firebase');
      const { doc, updateDoc, getDoc, collection, query, where, getDocs } = await import('firebase/firestore');
      
      const { getTimeBasedCollectionName } = await import('../utils/firebaseUtils');
      
      console.log('🔍 사용자 검색 시작:', { nickname, page, buttonType });
      
      // 1. 현재 시간 컬렉션 검색
      const currentCollection = getTimeBasedCollectionName(new Date());
      console.log('📅 현재 컬렉션 검색:', currentCollection);
      
      let userFound = false;
      let targetCollection = '';
      let targetUserDoc = null;
      
      const currentRef = collection(db, currentCollection);
      const currentQuery = query(
        currentRef,
        where('nickname', '==', nickname)
      );
      
      const currentSnapshot = await getDocs(currentQuery);
      console.log('현재 컬렉션 검색 결과:', currentSnapshot.docs.length);
      
      if (!currentSnapshot.empty) {
        userFound = true;
        targetCollection = currentCollection;
        targetUserDoc = currentSnapshot.docs[0];
        console.log('✅ 현재 컬렉션에서 사용자 발견');
      } else {
        // 2. 1시간 전 컬렉션 검색 (사용자 생성 후 2시간 유효)
        const oneHourAgo = new Date();
        oneHourAgo.setHours(oneHourAgo.getHours() - 1);
        const oneHourAgoCollection = getTimeBasedCollectionName(oneHourAgo);
        
        console.log('📅 1시간 전 컬렉션 검색:', oneHourAgoCollection);
        
        const oneHourAgoRef = collection(db, oneHourAgoCollection);
        const oneHourAgoQuery = query(
          oneHourAgoRef,
          where('nickname', '==', nickname)
        );
        
        const oneHourAgoSnapshot = await getDocs(oneHourAgoQuery);
        console.log('1시간 전 컬렉션 검색 결과:', oneHourAgoSnapshot.docs.length);
        
        if (!oneHourAgoSnapshot.empty) {
          userFound = true;
          targetCollection = oneHourAgoCollection;
          targetUserDoc = oneHourAgoSnapshot.docs[0];
          console.log('✅ 1시간 전 컬렉션에서 사용자 발견');
        }
      }
      
      if (userFound && targetUserDoc) {
        const userRef = doc(db, targetCollection, targetUserDoc.id);
        
        console.log('🎯 사용자 문서 정보:', {
          id: targetUserDoc.id,
          collection: targetCollection,
          nickname: targetUserDoc.data().nickname
        });
        
        const userData = targetUserDoc.data();
        const buttonClicks = userData.buttonClicks || [];
        
        // 새로운 클릭 정보 추가
        const newClickInfo = {
          page: page,
          buttonType: buttonType,
          timestamp: new Date().toISOString(),
          date: new Date().toLocaleDateString('ko-KR')
        };
        
        buttonClicks.push(newClickInfo);
        console.log('➕ 추가할 클릭 정보:', newClickInfo);
        console.log('📊 업데이트될 전체 클릭 정보:', buttonClicks);
        
        // DB 업데이트
        await updateDoc(userRef, {
          buttonClicks: buttonClicks
        });
        
        console.log('✅ DB 업데이트 완료:', `${page}에서 ${buttonType} 버튼 클릭 정보가 저장되었습니다.`);
      } else {
        console.error('❌ 사용자를 찾을 수 없습니다:', nickname);
        console.error('검색한 컬렉션들:', {
          current: currentCollection,
          oneHourAgo: getTimeBasedCollectionName(new Date(Date.now() - 60 * 60 * 1000))
        });
      }
    } catch (error) {
      console.error('❌ 버튼 클릭 정보 저장 중 오류:', error);
      // Firebase 에러 팝업 표시
      handleFirebaseError(error, '버튼 클릭 정보 저장 중 오류가 발생했습니다.');
    }
  };

  // TIP 기능 관련 핸들러들
  const handleTipButtonClick = () => {
    soundManager.playButtonClick();
    setShowTipOverlay(true);
  };

  const handleTipOverlayClick = () => {
    setShowTipOverlay(false);
  };

  const handleHintClick = () => {
    soundManager.playButtonClick();
    setShowHintPopup(true);
  };

  const handleHintPopupClick = () => {
    setShowHintPopup(false);
  };

  const handleHintOkClick = () => {
    soundManager.playButtonClick();
    setShowHintPopup(false);
  };

  const handleClearPopupClick = () => {
    setShowClearPopup(false);
    setShowSuccessCoinPopup(true);
  };

  const handleFailPopupClick = () => {
    setShowFailPopup(false);
    setShowFailCoinPopup(true);
  };

  const handleSuccessCoinPopupClick = () => {
    soundManager.playButtonClick();
    setShowSuccessCoinPopup(false);
    navigateWithSession('/progress-card');
  };

  const handleFailCoinPopupClick = () => {
    soundManager.playButtonClick();
    setShowFailCoinPopup(false);
    navigateWithSession('/progress-card');
  };

  return (
    <>
      <FadeInBackground 
        visible={bgVisible} 
        bgImage={currentBgImage}
        onClick={handleBackgroundClick}
        style={{ 
          cursor: isFadeInComplete && !isBgChanged ? 'pointer' : 'default',
          height: containerHeight
        }}
      >
        {!currentBgImage.includes('07quiz-bg0') && (
          <Bookmark 
            visible={bookmarkVisible} 
            zIndex={9999} 
          />
        )}
        {isBgChanged && (
          <ExitButton
            src={exitBtnImg}
            alt="나가기"
            onClick={handleExitButtonClick}
          />
        )}
        {isBgChanged && (
          <SkipButton
            src={skipBtnImg}
            alt="건너뛰기"
            onClick={handleSkipButtonClick}
          />
        )}
        {isBgChanged && (
          <TipButton
            src={questionImg}
            alt="팁"
            onClick={handleTipButtonClick}
          />
        )}
        <Title 
          src={titleImg} 
          alt="퀴즈 타이틀" 
          visible={titleVisible} 
        />
        <Zone1 
          src={zone1Img} 
          alt="퀴즈 영역2" 
          visible={zone1Visible} 
        />
        <Quiz 
          src={quizImg} 
          alt="퀴즈" 
          visible={quizVisible} 
        />
        <QuizButtonsContainer visible={quizButtonsVisible}>
          {[
            { index: 0, text: '푸른 소나무' },
            { index: 1, text: '하얀 소나무' }
          ].map(({ index, text }) => (
            <QuizButtonContainer
              key={index}
              isSelected={selectedQuiz === index}
              visible={quizButtonsVisible === 1}
              onClick={() => handleQuizButtonClick(index)}
            >
              <QuizButton
                src={selectedQuiz === index ? btn2Img : btn1Img}
                alt={`퀴즈 보기 ${index + 1}`}
              />
              <QuizButtonText isSelected={selectedQuiz === index}>{text}</QuizButtonText>
            </QuizButtonContainer>
          ))}
        </QuizButtonsContainer>
        <HintButton
          src={hintImg}
          alt="힌트"
          visible={hintVisible}
          onClick={handleHintClick}
        />
        <ConfirmButton
          src={confirmBtnImg}
          alt="확인"
          visible={confirmButtonVisible}
          onClick={handleConfirmButtonClick}
        />
        <HintPopup visible={showHintPopup} onClick={handleHintPopupClick}>
          <HintPopupContent onClick={(e) => e.stopPropagation()}>
            <HintPopupImage
              src={hint2Img}
              alt="힌트 팝업"
            />
            <HintOkButton
              src={hintOkBtnImg}
              alt="확인 버튼"
              onClick={handleHintOkClick}
            />
          </HintPopupContent>
        </HintPopup>
        <ClearPopup visible={showClearPopup} onClick={handleClearPopupClick}>
          <ClearPopupImage
            src={clearImg}
            alt="클리어"
            visible={showClearPopup}
          />
        </ClearPopup>
        <FailPopup visible={showFailPopup} onClick={handleFailPopupClick}>
          <FailPopupImage
            src={failImg}
            alt="실패"
            visible={showFailPopup}
          />
        </FailPopup>
        <SuccessCoinPopup visible={showSuccessCoinPopup}>
          <SuccessCoinPopupContent onClick={(e) => e.stopPropagation()}>
            <SuccessCoinPopupImage
              src={successCoinImg}
              alt="성공 코인"
              visible={showSuccessCoinPopup}
            />
            <CoinPopupOkButton
              src={hintOkBtnImg}
              alt="확인 버튼"
              visible={showSuccessCoinPopup}
              onClick={handleSuccessCoinPopupClick}
            />
          </SuccessCoinPopupContent>
        </SuccessCoinPopup>
        <FailCoinPopup visible={showFailCoinPopup}>
          <FailCoinPopupContent onClick={(e) => e.stopPropagation()}>
            <FailCoinPopupImage
              src={failCoinImg}
              alt="실패 코인"
              visible={showFailCoinPopup}
            />
            <CoinPopupOkButton
              src={hintOkBtnImg}
              alt="확인 버튼"
              visible={showFailCoinPopup}
              onClick={handleFailCoinPopupClick}
            />
          </FailCoinPopupContent>
        </FailCoinPopup>
        {/* EXIT 팝업 컴포넌트 */}
        <ExitPopupComponent
          visible={showExitPopup}
          onClose={handleExitPopupClose}
          onExit={handleExitConfirmed}
          onNavigate={navigateWithSession}
          navigatePath="/progress-card?from=exit"
          exitPopupImage={exitPopupImg}
          coinGetImage={exitCoinGetImg}
          pageInfo="quiz2"
          buttonType="exit"
        />
        {/* SKIP 팝업 */}
        {showSkipPopup && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100dvw',
            height: '100dvh',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
          }}>
            <div style={{
              width: '100dvw',
              position: 'relative'
            }}>
              <BluePopup
                onClose={handleSkipPopupClose}
              >
                <div style={{ 
                  fontSize: '6dvw', 
                  marginBottom: '2dvh'
                }}>
                  '이현성' 시나리오를{'\n'}이탈하시겠습니까?
                </div>
                <div style={{ 
                  fontSize: '3.8dvw'
                }}>
                  실패 보상 지급과 함께{'\n'}다음 인물의 시나리오가 진행됩니다.
                </div>
              </BluePopup>
              {showSkipButtons && (
                <div style={{ 
                  display: 'flex', 
                  justifyContent: 'center', 
                  gap: '3dvw',
                  position: 'absolute',
                  bottom: '-30%',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: '80%',
                  zIndex: 1001,
                  opacity: showSkipButtons ? 1 : 0,
                  transition: 'opacity 0.3s ease'
                }}>
                  <img
                    src={prevBtnImg}
                    alt="이전"
                    style={{ 
                      width: '40dvw', 
                      height: 'auto',
                      cursor: 'pointer'
                    }}
                    onClick={handleSkipPopupClose}
                  />
                  <img
                    src={okBtnImg}
                    alt="네"
                    style={{ 
                      width: '40dvw', 
                      height: 'auto',
                      cursor: 'pointer'
                    }}
                    onClick={handleSkipConfirmed}
                  />
                </div>
              )}
            </div>
          </div>
        )}
        {/* TIP 오버레이 */}
        <TipOverlay
          visible={showTipOverlay}
          onClick={handleTipOverlayClick}
        />
        
        {/* Firebase 에러 팝업 */}
        <FirebaseErrorPopup
          isVisible={errorState.isError}
          onClose={hideError}
          message={errorState.errorMessage}
        />
      </FadeInBackground>
    </>
  );
};

export default withUrlValidation(Quiz2Page, {
  requireValidation: true,
  showCountdown: true
}); 